import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
export default {
  name: "InboundDeliveryRelatedFilesTable",
  props: {
    title: String,
    loading: Boolean,
    documentTags: Array,
    items: {},
    documentType: String,
    nameKey: String,
    idKey: String,
    route: String
  },
  data: function data() {
    return {
      tableShown: false,
      headers: [{
        text: "FILE NAME",
        align: "start",
        value: "filename",
        width: "30%"
      }, {
        text: "Tag",
        align: "start",
        value: "tag",
        width: "20%"
      }, {
        text: this.documentType,
        align: "start",
        value: "content",
        width: "50%"
      }],
      filters: {
        search: null,
        selectedTags: []
      }
    };
  },
  computed: {
    isFilterBtnAvailable: function isFilterBtnAvailable() {
      return !(this.filters.search || this.filters.selectedTags.length);
    }
  },
  methods: {
    getItemName: function getItemName(item) {
      return item[this.documentType][this.nameKey];
    },
    openFileUrl: function openFileUrl(url) {
      window.open(url, "_blank");
    },
    goToItemDetails: function goToItemDetails(item) {
      var detailsRoute = "";
      var routeParams = {};
      detailsRoute = this.route;
      return {
        name: detailsRoute,
        params: {
          id: item[this.documentType][this.idKey],
          routeParams: routeParams
        }
      };
    },
    ApplyFilters: function ApplyFilters() {
      this.$emit("filterList", this.filters);
    }
  }
};